import React, { useEffect, useState } from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';

export const Hero = ({ data }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    setIsVisible(true);
    
    // Rotate through HVAC images
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % data.images.length
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [data.images.length]);

  const scrollToSolutions = () => {
    document.getElementById('solutions')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-left">
          <div className={`hero-eyebrow ${isVisible ? 'fade-in-up' : ''}`} data-testid="hero-eyebrow">
            HVAC · Renewable Energy · Engineering
          </div>
          <h1 className={`hero-title ${isVisible ? 'fade-in-up' : ''}`}>
            {data.title}
          </h1>
          <p className={`hero-subtitle ${isVisible ? 'fade-in-up delay-1' : ''}`}>
            {data.subtitle}
          </p>
          <div className={`hero-buttons ${isVisible ? 'fade-in-up delay-2' : ''}`}>
            <button className="btn-primary" onClick={scrollToSolutions}>
              {data.cta1}
              <ArrowRight size={20} />
            </button>
            <button className="btn-secondary" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
              {data.cta2}
            </button>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-visual">
            <div className="hero-hvac-showcase">
              {data.images.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`HVAC System ${index + 1}`}
                  className={`hero-hvac-image ${index === currentImageIndex ? 'active' : ''}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <button className="scroll-indicator" onClick={scrollToSolutions}>
        <ChevronDown size={32} />
      </button>
    </section>
  );
};